import { combineReducers } from 'redux';
import auth from './login_reducer';
import model from './model_reducer';
import user from './user_reducer';
import iframe from './iframe_reducer';

const rootReducer = combineReducers({
    auth,
    model,
    user,
    iframe
})

export default rootReducer;